import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_public")({
	component: RouteComponent,
});

function RouteComponent() {
	// The app shell locks `html, body { overflow: hidden }` and scrolls via inner
	// containers. Public routes have no such shell, so this wrapper owns the scroll:
	// `h-dvh` pins it to the (dynamic) viewport and `overflow-y-auto` lets tall
	// content — e.g. the Clerk sign-up card on mobile — scroll instead of clipping.
	return (
		<div className="h-dvh overflow-y-auto">
			<Outlet />
		</div>
	);
}
